<template>
  <article class="layout-section -bg-shade">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">{{ wp.resources.title }}</h2>
    </div>

    <section class="layout-section__index">
      <div v-for="entry in wp.resources.links" :key="entry.title" class="card -bigger">
        <h3 class="card__title">{{ entry.title }}</h3>
        <p v-if="entry.text">{{ entry.text }}</p>

        <a
          v-if="entry.external && entry.url"
          :href="entry.url"
          target="_blank"
          rel="noopener noreferrer"
          class="link card__cta"
        >
          En savoir plus
          <SvgIcon id="action-external" />
        </a>

        <RouterLink
          v-else-if="entry.page && entry.page.length"
          :to="$wp.getPageRouteById(entry.page[0])"
          class="link card__cta"
        >
          En savoir plus
          <SvgIcon id="action-arrow" />
        </RouterLink>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'ResourcesIndex',
  inject: ['wp']
}
</script>
